module.exports = __webpack_public_path__ + "static/media/play-button.065e2b65.svg";